import * as React from 'react';

import Github from './github.svg?react';
import Slack from './slack.svg?react';
import Walmart from './walmart.svg?react';

import Play from './play.svg?react';

import Home from './home.svg?react';
import Logout from './logout.svg?react';
import Notes from './notes.svg?react';
import Settings from './settings.svg?react';
import Trash from './trash.svg?react';

import AI from './ai.svg?react';
import Chart from './chart.svg?react';
import Clock2 from './clock2.svg?react';
import Clock3 from './clock3.svg?react';
import Clock4 from './clock4.svg?react';
import Clock5 from './clock5.svg?react';
import Clock6 from './clock6.svg?react';
import Cloud from './cloud.svg?react';
import Cloud3 from './cloud3.svg?react';
import Cloud4 from './cloud4.svg?react';
import Credentials from './credentials.svg?react';
import Trigger from './trigger.svg?react';
import Trigger2 from './trigger2.svg?react';
import Trigger3 from './trigger3.svg?react';

import { FiClock, IoAlert, TbCategoryPlus } from '@/components/react-icons/main';
import Cancel from './cancel.svg?react';
import Checkmark from './checkmark.svg?react';
import More from './more.svg?react';

export const iconMap = {
  Github,
  Slack,
  Walmart,
  Play,
  Cancel,
  Notes,
  Trash,
  Home,
  Settings,
  Logout,
  Cloud,
  Cloud3,
  Cloud4,
  Clock: FiClock,
  Clock2,
  Clock3,
  Clock4,
  Clock5,
  Clock6,
  Chart,
  Trigger,
  Trigger2,
  Trigger3,
  More,
  Start: TbCategoryPlus,
  Incomplete: IoAlert,
  AI,
  Credentials,
  Checkmark
};

const SVG = React.memo(({ icon, fallbackIcon = null, basic = false, type = 'svg', invert = false, className, title, titleDelay, span = false, onClick = () => {} }) => {
  const Icon = iconMap[icon];
  const Fallback = iconMap[fallbackIcon];
  const [imgError, setImgError] = React.useState(false);

  React.useEffect(() => {
    setImgError(false);
  }, [icon]);

  const handleImgError = (e) => {
    setImgError(true);
  };

  if (typeof icon === 'function') {
    const Component = icon;
    return <Component />;
  }

  if (imgError) {
    if (typeof fallbackIcon === 'function') {
      const Component = fallbackIcon;
      return <Component />;
    }

    if (Fallback) {
      return <Fallback />;
    }

    return null;
  }

  if (span === true) {
    const shouldRenderImg = typeof icon === 'string' && !!icon && !Icon;
    return (
      <span className={`svg-wrapper ${className || ''} ${basic && !!Icon ? 'basic' : ''} ${invert && !!Icon ? 'invert' : ''}`} onClick={onClick} data-title={title} data-title-delay={titleDelay}>
        {!!Icon && <Icon />}
        {shouldRenderImg && <img className={className} src={icon} alt={'SVG'} onError={handleImgError} />}
      </span>
    );
  }

  const shouldRenderImg = typeof icon === 'string' && !!icon && !Icon;
  return (
    <div className={`svg-wrapper ${className || ''} ${basic && !!Icon ? 'basic' : ''} ${invert && !!Icon ? 'invert' : ''}`} onClick={onClick} data-title={title} data-title-delay={titleDelay}>
      {!!Icon && <Icon />}
      {shouldRenderImg && <img className={className} src={icon} alt={'SVG'} onError={handleImgError} />}
    </div>
  );
});
SVG.displayName = 'SVG';

export default SVG;
